import Login from '../../pages/Login.vue'
import type { RouteRecordRaw } from 'vue-router'
import { redirectIfAuth } from '../middleware/auth'

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    component: Login,
    beforeEnter: redirectIfAuth
  }
]
